export const bloodBankRouteDef = [
    {
        path: ':id/:resource/bloodTransfusion',
        component: 'BllodBankTemplateComponent',
        data: {
            selector: 'app-bllod-bank-template',
            resource: 'ip_bloodBank_transfusion_form',
            action: 'MODIFY'
        }
    },
    {
        path: ':id/:resource/bloodReaction',
        component: 'BllodBankTemplateComponent',
        data: {
            selector: 'app-bllod-bank-template',
            resource: 'ip_bloodBank_reaction_form',
            action: 'MODIFY'
        }
    },
    {
        path: ':id/:resource/viewReaction',
        component: 'BllodBankTemplateComponent',
        data: {
            selector: 'app-bllod-bank-template',
            resource: 'worklist_view_reaction',
            action: ''
        }
    },
    {
        path: ':id/:resource/trackRequest',
        component: 'BloodBankDataGridComponent',
        data: {
            selector: 'app-blood-bank-data-grid',
            resource: 'per_patient_track_bloodBank',
            action: 'MODIFY'
        }
    },
    {
        path: 'uploadedfile_metadata',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'uploadedfile_metadata_tab',
            action: 'IMAGE_VIEWER',
        }
    },
    {
        path: ':resource/:id/view',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'donor_registration_form',
            id: 'id',
            action: 'VIEW'
        }
    },
    {
        path: 'tti_screening',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'tti_screening',
            action: 'LIST'
        }
    },
    {
        path: 'bb_component_separation',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'bb_component_separation',
            action: 'LIST'
        }
    },
    {
        path: ':id/:resource/raise_blood_bank_orders',
        component: 'EditableGridWithBannerComponent',
        data: {
            selector: 'kx-editable-grid-with-banner'
        }
    },
    {
        path: ':id/:resource/component_separation',
        component: 'BloodBankEditableGridComponent',
        data: {
            selector: 'app-blood-bank-editable-grid'
        }
    },
    {
        path: 'organization_request',
        component: 'OrganizationRequestFormComponent',
        data: {
            selector: 'app-organization-request-form',
            resource: 'organization_request',
            action: 'MODIFY'
        }
    },
    {
        path: 'barcode',
        component: 'BarcodeComponent',
        data: {
            selector: 'app-barcode'
        }
    },
    {
        path: ':id/:resource/organizationRequestCancel',
        component: 'EditableGridWithBannerComponent',
        data: {
            selector: 'kx-editable-grid-with-banner'
        }
    },
    {
        path: ':id/:resource/organizationRequestView',
        component: 'EditableGridWithBannerComponent',
        data: {
            selector: 'kx-editable-grid-with-banner'
        }
    }
]